/**
 * Version 1 of public Cross Flow API
 */

export var VERSION = 1;
export var createAPIv1 = function createAPIv1(onOpen) {
  return {
    open: function open(options) {
      return onOpen(options);
    }
  };
};